import { render, staticRenderFns } from "./Hui.vue?vue&type=template&id=f5ad40a6&scoped=true&"
import script from "./Hui.vue?vue&type=script&lang=js&"
export * from "./Hui.vue?vue&type=script&lang=js&"
import style0 from "./Hui.vue?vue&type=style&index=0&id=f5ad40a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ad40a6",
  null
  
)

export default component.exports